import { useEffect, useState } from 'react';
import { paramCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// material
import { Container } from '@mui/material';
// redux
import { useDispatch, useSelector, RootState } from '../../../redux/store';
import { getUserList } from '../../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import { Link as RouterLink, Navigate } from 'react-router-dom';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import UserNewForm from '../../../components/_dashboard/user/UserNewForm';
import useAuth from '../../../hooks/useAuth';
import ContactCreateForm from 'components/_dashboard/contact/ContactNewForm';
import SiteNewForm from 'components/_dashboard/contacts-sites/ContactSiteForm';
import { axios } from 'utils/axios';

// ----------------------------------------------------------------------

export default function CreateContactSite() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { id = '', clientId } = useParams();
  const isEdit = pathname.includes('edit');
  const isDetails = pathname.includes('details');
  const [contactSite, setContactSite] = useState<any>({});

  useEffect(() => {
    if (id) {
      fetchContactSiteById(id);
    }
    if (!isEdit) {
      setContactSite({});
    }
  }, [id, isEdit]);

  const fetchContactSiteById = async (id: any) => {
    const response = await axios.get(`/rest/api/contacts/sites/${id}`);
    console.log(response.data.data.data);
    setContactSite(response.data.data.data);
  };
  return (
    <Page title="Contact Site: Create a new contact site">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            isDetails ? 'Contact Site Details' : isEdit ? 'Edit Contact Site' : 'Create a New Site'
          }
          links={[
            { name: 'Dashboard', href: '/dashboard' },
            {
              name: 'Contacts Sites',
              href: clientId
                ? `/dashboard/contacts/details/${clientId}`
                : '/dashboard/contacts-sites/list'
            },
            { name: isDetails ? 'Details' : isEdit ? 'Edit Site' : 'New Contact Site' }
          ]}
        />

        <SiteNewForm isEdit={isEdit} currentSite={contactSite} isDetails={isDetails} />
      </Container>
    </Page>
  );
}
